// A nova estrutura do portal foi liberada para todos os clientes.
// Perfis com experiências próprias, como "corretor", continuam tratados
// pelos fluxos específicos de rota e navegação.
export const canUseNovaEstruturaPortal = () => true;
